module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5b1a4d196ba87f7bcf2f697b5daf51b9.png";